import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Chat from "./pages/Chat";
import Landing from "./pages/Landing";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#405de6" },
    secondary: { main: "#fd1d1d" },
    background: { default: "#fafafa" },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
  },
});

function RequireAuth({ children }) {
  const location = useLocation();
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Register service worker for push notifications
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then(reg => {
        console.log("Service Worker registered", reg);
      }).catch(err => {
        console.log("Service Worker registration failed", err);
      });
    }

    // Cleanup event listener
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => setDeferredPrompt(null));
    }
  };

  // Check if user is logged in
  const isLoggedIn = !!localStorage.getItem("token");

  // Global error handler function (call this in your API interceptors)
  // eslint-disable-next-line
  const handleAuthError = (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Clear local storage/session
      localStorage.clear();
      // Redirect to login
      window.location.href = '/login';
    }
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                isLoggedIn ? <Navigate to="/dashboard" replace /> : <Landing />
              }
            />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route 
              path="/dashboard" 
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              } 
            />
            <Route 
              path="/chat/:userId" 
              element={
                <RequireAuth>
                  <Chat />
                </RequireAuth>
              } 
            />
            <Route path="*" element={<Navigate to={isLoggedIn ? "/dashboard" : "/"} />} />
          </Routes>
        </Router>
      </ThemeProvider>
      {deferredPrompt && (
        <button
          style={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 9999,
            background: "#405de6",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "12px 20px",
            fontWeight: 600,
            fontSize: "1rem",
            boxShadow: "0 2px 8px rgba(60,60,120,0.13)",
            cursor: "pointer"
          }}
          onClick={handleInstall}
        >
          Install RazChatz
        </button>
      )}
    </>
  );
}

export default App;